<template>
  <button tabindex="0" class="actions-item" @click="favoriteClicked()">
    <span :class="favoriteClass"></span>
  </button>
</template>

<script>
export default {
  name: "FavoriteButton",
  props: ["track", "shouldRemove", "index"],
  data() {
    return {
      favoriteClass: "iconfavorite2"
    };
  },
  mounted() {
    const favoriteArr =
      localStorage.favoriteArr && localStorage.favoriteArr !== "undefined"
        ? JSON.parse(localStorage.favoriteArr)
        : [];
    const track = this.track;
    if (favoriteArr.length) {
      favoriteArr.forEach(item => {
        if (item.id === track.id) {
          this.favoriteClass = "iconfavorite";
        }
      });
    }
  },

  methods: {
    favoriteClicked() {
      const track = this.track;
      let parsedLS =
        localStorage.favoriteArr && localStorage.favoriteArr !== "undefined"
          ? JSON.parse(localStorage.favoriteArr)
          : [];
      if (this.favoriteClass === "iconfavorite") {
        this.favoriteClass = "iconfavorite2";
        parsedLS = parsedLS.filter(item => {
          return item.id !== track.id;
        });

        if (this.shouldRemove) {
          this.$emit("removeItem", this.index);
        }
      } else {
        this.favoriteClass = "iconfavorite";
        parsedLS.push(track);
      }
      localStorage.favoriteArr = JSON.stringify(parsedLS);
    }
  }
};
</script>

<style>
.card:hover .close {
  display: block;
  right: 8px;
  font-size: 12px;
}
.card-text {
  font-size: 0.8em;
  margin-top: 5px;
}

button {
  background: none;
  box-shadow: none;
  border: none;
  font-size: 18px;
  margin: 0;
}

.actions-item {
  padding: 8px;
  color: #c53526;
  font-size: 15px;
}

.actions-item--bigger {
  font-size: 20px;
}

.event-item {
  padding: 0 10px;
}

.artist-text {
  font-size: 14px;
  text-align: left;
}
</style>
